import { STEPS } from "@/lib/questionnaire-schema";
import { SENSORY_PROFILE_STEPS } from "@/lib/sensory-profile-schema";

/** Canonical SPA paths — match `src/routes/` file routes. */
export const ROUTES = {
  home: "/",
  getStarted: "/get-started",
  intake: "/intake",
  intakeSubmitted: "/intake/submitted",
  sensoryProfile: "/sensory-profile",
  sensoryProfileSubmitted: "/sensory-profile/submitted",
} as const;

export type IntakeStepId = (typeof STEPS)[number]["id"];
export type SensoryProfileStepId = (typeof SENSORY_PROFILE_STEPS)[number]["id"];

const INTAKE_STEP_IDS = new Set<string>(STEPS.map((step) => step.id));
const SENSORY_PROFILE_STEP_IDS = new Set<string>(
  SENSORY_PROFILE_STEPS.map((step) => step.id),
);

const PAGEVIEW_SKIP = new Set<string>([
  ROUTES.getStarted,
  ROUTES.intake,
  ROUTES.sensoryProfile,
]);

export function isIntakeStepId(value: string): value is IntakeStepId {
  return INTAKE_STEP_IDS.has(value);
}

export function isSensoryProfileStepId(
  value: string,
): value is SensoryProfileStepId {
  return SENSORY_PROFILE_STEP_IDS.has(value);
}

export function firstIntakeStepId(): IntakeStepId {
  return STEPS[0].id;
}

export function firstSensoryProfileStepId(): SensoryProfileStepId {
  return SENSORY_PROFILE_STEPS[0].id;
}

export function intakeScreenPath(stepId: IntakeStepId): string {
  return `${ROUTES.intake}/${stepId}`;
}

export function sensoryProfileScreenPath(stepId: SensoryProfileStepId): string {
  return `${ROUTES.sensoryProfile}/${stepId}`;
}

export function normalizePathname(pathname: string): string {
  return pathname.replace(/\/+$/, "") || "/";
}

/** Skip layout URLs that only redirect to the first named step. */
export function shouldCaptureRoutePageview(pathname: string): boolean {
  return !PAGEVIEW_SKIP.has(normalizePathname(pathname));
}
